import { Form } from 'react-bootstrap';
type Props = {
  children: JSX.Element;
};

export default function ValidationError({ children }: Props) {
  return (
    <Form.Control.Feedback type="invalid">{children} </Form.Control.Feedback>
  );
}
